import React, { Component } from "react";
import { TweenMax } from 'gsap';
import { connect } from "react-redux";
import { twoDDarkPatternCorrect, twoDDarkPatternIncorrect } from "../../actions/actionCreators.js";

const mapDispatchToProps = dispatch => {
	return {
        twoDDarkPatternIncorrect: () => dispatch(twoDDarkPatternIncorrect()),
        twoDDarkPatternCorrect: () => dispatch(twoDDarkPatternCorrect())
	};
};

class SimpleDarkPattern2dView extends Component {

    constructor(props) {
		super(props);
		this.state = {
			shake: false,
            done: false
		};
	}

	clicked() {
        this.props.twoDDarkPatternCorrect();
		this.setState({
			// shake: true,
			done: true
		});
		TweenMax.delayedCall(0.5, () => this.props.adComplete());
    }

    shake() {
		this.setState({ shake: true })
        TweenMax.delayedCall(0.4, () => this.setState({ shake: false }))
        this.props.twoDDarkPatternIncorrect();
	}

    componentWillUnmount () {
        TweenMax.killAll(true, true, true, true);
    }

	render () {
        const childStyles = {
			zIndex: this.props.z,
			left: this.props.x + "%",
			top: this.props.y + "%"
		};
		return (
			<div className={`floatingad ${this.state.shake ? 'shake' : ''} ${this.state.done ? 'out' : ''} `}  style={childStyles}>
				<div className="borderTop">
					<div className="dot"></div>
					<div className="dot"></div>
					<div className="dot"></div>
				</div>
				<p>{this.props.adText}</p>
				<div className="buttons">
					<button className="yes" onClick={ this.clicked.bind(this)}>Yes</button>
				</div>
			</div>
			
		)
	}
	
}

const SimpleDarkPattern2d = connect(()=>({}), mapDispatchToProps)(SimpleDarkPattern2dView);
export default SimpleDarkPattern2d;



// WEBPACK FOOTER //
// ./src/components/darkpatterns2d/SimpleDarkPattern2d.js